import { addValidationRule } from 'formsy-react';
import { PHONE_REGEXP, EMAIL_REGEXP } from 'common';


function validateLogin(val, type) {
  if (val == null || val === '')
    return 'Поле не може бути порожнім';

  let title = '';
  if (type.includes('phone'))
    title += 'телефон';

  if (type.includes('email')) {
    if (title.length > 0)
      title += ' або';

    title += ' пошту';
  }


  const notEmail = (type.includes('email') && !(EMAIL_REGEXP.test(val)));
  const notPhone =  (type.includes('phone') && !(PHONE_REGEXP.test(val)));

  if (notEmail && notPhone)
    return `Поле має містити ${title}`;

  return true;
}

addValidationRule('isExistyEmailOrPhone', (values, val) => (validateLogin(val, 'email,phone')));
addValidationRule('isExistyEmail', (values, val) => (validateLogin(val, 'email')));
addValidationRule('isExistyPhone', (values, val) => (validateLogin(val, 'phone')));

addValidationRule('isSecure', (values, value) => {
  if (value == null || value.length === 0)
    return 'Поле не може бути порожнім!';

  const val = value.trim();

  if (val.match(/[А-я]/) !== null)
    return 'Поле повинно містити букви латинського алфавиту (A-z)';

  if (val.length < 8)
    return 'Поле повинно бути не менше 8 символів!';

  if (val.length > 14)
    return 'Поле повинно бути не більше 14 символів!';

  if (val.match(/[A-Z]/) === null || val.match(/[a-z]/) === null)
    return 'Поле повинно містити рядкові та заголовні букви';

  if (val.match(/[0-9]/) === null)
    return 'Поле повинно містити цифри (0-9)';

  return true;
});
